// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/security.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Enum representing the passphrase hash security type.
 *
 * @generated from enum ai.h2o.deploy.PassphraseHashSecurityType
 */
export const PassphraseHashSecurityType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.PassphraseHashSecurityType",
  [
    {no: 0, name: "PASSPHRASE_HASH_TYPE_UNSPECIFIED"},
    {no: 1, name: "PASSPHRASE_HASH_TYPE_PLAINTEXT"},
    {no: 2, name: "PASSPHRASE_HASH_TYPE_BCRYPT"},
    {no: 3, name: "PASSPHRASE_HASH_TYPE_PBKDF2"},
  ],
);

/**
 * @generated from enum ai.h2o.deploy.AuthorizationProtocolSecurityType
 */
export const AuthorizationProtocolSecurityType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.AuthorizationProtocolSecurityType",
  [
    {no: 0, name: "AUTHORIZATION_PROTOCOL_UNSPECIFIED"},
    {no: 1, name: "AUTHORIZATION_PROTOCOL_OIDC"},
  ],
);

/**
 * Enum representing the disabled state security type.
 *
 * @generated from enum ai.h2o.deploy.DisabledStateSecurityType
 */
export const DisabledStateSecurityType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.DisabledStateSecurityType",
  [
    {no: 0, name: "DISABLED_STATE_SECURITY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISABLED_STATE_SECURITY_TYPE_DISABLED", localName: "DISABLED"},
  ],
);

/**
 * Represents the security properties of a Deployment.
 *
 * @generated from message ai.h2o.deploy.Security
 */
export const Security = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Security",
  () => [
    { no: 1, name: "passphrase", kind: "message", T: AuthenticationPassphrase, oneof: "authentication" },
    { no: 2, name: "token_auth", kind: "message", T: AuthorizationAccessToken, oneof: "authentication" },
    { no: 3, name: "disabled_security", kind: "enum", T: proto3.getEnumType(DisabledStateSecurityType), oneof: "authentication" },
  ],
);

/**
 * A passphrase is expected to be supplied in an `Authorization` header
 * in the form `Authorization: Bearer <passphrase>`.
 *
 * @generated from message ai.h2o.deploy.AuthenticationPassphrase
 */
export const AuthenticationPassphrase = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.AuthenticationPassphrase",
  () => [
    { no: 1, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "passphrase_hash_type", kind: "enum", T: proto3.getEnumType(PassphraseHashSecurityType) },
  ],
);

/**
 * An access token is expected to be supplied in an `Authorization` header
 * in the form of `Authorization: Bearer <token>`.
 *
 * @generated from message ai.h2o.deploy.AuthorizationAccessToken
 */
export const AuthorizationAccessToken = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.AuthorizationAccessToken",
  () => [
    { no: 1, name: "authentication_protocol", kind: "enum", T: proto3.getEnumType(AuthorizationProtocolSecurityType) },
  ],
);

